import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ChartCapitalStructureData from 'pages/Entrepeneur/Feedbacks/charts/ChartCapitalStructureData';
import NewsComponent from '../../Investor/NewsComponent';
import pdfIcon from '../../../assets/images/pdfIcon.png';
import intraLinkIcon from '../../../assets/images/intraLinkIcon.png';
import webCastIcon from '../../../assets/images/webCastIcon.png';

const corpoDoc = [
  {
    title: 'Annual_report.pdf',
    link:
      'http://drivee.praexo.io/api/demofiles/Drivee%20Annual%20Report%202019.pdf'
  },
  {
    title: 'ShareHolding_structure.pdf',
    link: 'http://drivee.praexo.io/api/demofiles/INCONNU'
  },
  {
    title: 'Shareholders_agreement.pdf',
    link: 'http://drivee.praexo.io/api/demofiles/INCONNU'
  }
];

const virtualData = [{ title: 'Intralinks' }];

const webcastData = [{ title: 'ZOOM' }];

const newsData = [
  {
    companyName: 'Le Monde',
    date: 'March 12, 2020 10:02 am',
    title: 'News about a comparative company'
  },
  {
    companyName: 'Bloomberg',
    date: 'March 12, 2020 09:58 am',
    title: 'News about the sector'
  },
  {
    companyName: 'Bloomberg',
    date: 'March 12, 2020 09:53 am',
    title: 'News about the company'
  }
];

const infoData = [
  {
    title: 'Teaser.pdf',
    link: 'http://drivee.praexo.io/api/demofiles/INCONNU'
  },
  {
    title: 'Equity_story.pdf',
    link: 'http://drivee.praexo.io/api/demofiles/Drivee%20Equity%20Story.pdf'
  },
  {
    title: 'Terms_and_conditions.pdf',
    link: 'http://drivee.praexo.io/api/demofiles/INCONNU'
  }
];

const equityData = [
  {
    title: 'BG_report.pdf',
    link: 'http://drivee.praexo.io/api/demofiles/Drivee_BG%20Research.pdf'
  },
  {
    title: 'Broker2.pdf',
    link: 'http://drivee.praexo.io/api/demofiles/INCONNU'
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  container: {
    flexGrow: 1,
    margin: '0 auto',
    width: '80%',
    maxWidth: 900,
    textAlign: 'left'
  },
  description: {
    padding: 15,
  },
  fullWidth: {
    zIndex: 1,
    justifyContent: 'center',
    height: '200px',
    display: 'flex',
    flexDirection: 'column'
  },
  desc: {
    fontFamily: 'PT serif',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#252525',
    margin: '1rem 0'
  },
  text: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    lineHeight: '22px',
    color: '##252525'
  },
  data: {
    display: 'flex',
    margin: '3.5rem auto'
  },
  dataCard: {
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.34)',
    background: '#FFF',
    textAlign: 'center',
    maxWidth: '90%',
    width: 450,
    minHeight: '350px',
    height: '350px',
    marginTop: '1.5rem',
    padding: '1.1rem'
  },
  value: {
    display: 'block',
    textAlign: 'left',
    marginTop: '.5rem',
    marginBottom: '1.5rem',
    fontFamily: 'PT sans',

    '& span': {
      color: '#002380',
      fontFamily: 'PT serif',
      fontWeight: 'bold',
      marginRight: '1rem',
      float: 'right'
    }
  },
  docContainer: {
    margin: '2.7rem 0'
  },
  doc: {
    margin: '.5rem 0',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    '& p': {
      marginLeft: 15
    }
  },
  docs: {
    margin: '1.1rem 0'
  },
  docTitle: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#252525'
  },

  virtualTitle: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#002380'
  },
  newsContainer: {
    margin: '2.7rem 0'
  },
  newsPaper: {
    maxHeight: '231px',
    margin: '1.1rem 0',
    padding: '1.1rem',
    overflow: 'auto'
  }
}));

const CompanyInfos = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.fullWidth}>
        <Typography className={classes.desc} color="initial" variant="h1">
          Description
        </Typography>
        <Paper className={classes.description} elevation={0}>
          <Typography className={classes.text} color="initial" variant="p">
          Drivee is a Provider of on-demand transportation services intended to
          promote mobility in cities. The company's services offer clean, modern
          cars with added features including choice of music, magazines, water,
          among others, driven by hand-picked and specially trained drivers,
          providing users with affordable, safe, and reliable rides wherever
          required. The company’s headquarters are based in San Francisco. It
          employs 425 employees in 3 countries. Its latest round of financing
          was a $75m serie-B raised in April 2019.{' '}
          </Typography>
        </Paper>
       
      </div>
      <div className={classes.data}>
        <div>
          <Typography className={classes.desc} color="initial" variant="p">
            Key terms
          </Typography>
          <Paper className={classes.dataCard}>
            <Typography className={classes.value} color="initial" variant="p">
              Number of existing shares: <span>150m</span>
            </Typography>
            <Typography className={classes.value} color="initial" variant="p">
              Capital raising amount <span>€175m</span>
            </Typography>
            <Typography className={classes.value} color="initial" variant="p">
              Pre-money targeted valuation: <span>€950m - €1,000m</span>
            </Typography>
            <Typography className={classes.value} color="initial" variant="p">
              Percentage of share capital: <span>14.9% - 15.6%</span>
            </Typography>
            <Typography className={classes.value} color="initial" variant="p">
              Primary / Secondary: <span>100% / 0%</span>
            </Typography>
            <Typography className={classes.value} color="initial" variant="p">
              Nature of instrument: <span>Ordinary shares</span>
            </Typography>
          </Paper>
        </div>
        <div>
          <Typography className={classes.desc} color="initial" variant="p">
            Overview of capital structure
          </Typography>
          <div className={classes.dataCard}>
            <ChartCapitalStructureData />
          </div>
        </div>
      </div>
      <div className={classes.docContainer}>
        <Typography className={classes.desc} color="initial" variant="p">
          Information related to the capital raising
        </Typography>
        <div className={classes.docs}>
          {infoData.map((doc) => (
            <Paper
              className={classes.doc}
              onClick={() => window.open(doc.link, '_blank')}>
              <img alt="pdf-icon" src={pdfIcon} width="25px" />
              <p className={classes.docTitle}>{doc.title}</p>
            </Paper>
          ))}
        </div>
      </div>
      <div className={classes.docContainer}>
        <Typography className={classes.desc} color="initial" variant="p">
          Equity research
        </Typography>
        <div className={classes.docs}>
          {equityData.map((doc) => (
            <Paper
              className={classes.doc}
              onClick={() => window.open(doc.link, '_blank')}>
              <img alt="pdf-icon" src={pdfIcon} width="25px" />
              <p className={classes.docTitle}>{doc.title}</p>
            </Paper>
          ))}
        </div>
      </div>
      <div className={classes.docContainer}>
        <Typography className={classes.desc} color="initial" variant="p">
          Management presentation
        </Typography>
        <div className={classes.docs}>
          {webcastData.map((doc) => (
            <Paper className={classes.doc}>
              <img alt="pdf-icon" src={webCastIcon} width="25px" />
              <p className={classes.docTitle}>{doc.title}</p>
            </Paper>
          ))}
        </div>
      </div>
      <div className={classes.docContainer}>
        <Typography className={classes.desc} color="initial" variant="p">
          Virtual Data Room
        </Typography>
        <div className={classes.docs}>
          {virtualData.map((data) => (
            <Paper className={classes.doc}>
              <img alt="pdf-icon" src={intraLinkIcon} width="25px" />
              <p className={classes.virtualTitle}>{data.title}</p>
            </Paper>
          ))}
        </div>
      </div>
      <div className={classes.docContainer}>
        <Typography className={classes.desc} color="initial" variant="p">
          Corporate & Regulatory information
        </Typography>
        <div className={classes.docs}>
          {corpoDoc.map((doc) => (
            <Paper
              className={classes.doc}
              onClick={() => window.open(doc.link, '_blank')}>
              <img alt="pdf-icon" src={pdfIcon} width="25px" />
              <p className={classes.docTitle}>{doc.title}</p>
            </Paper>
          ))}
        </div>
      </div>

      <div className={classes.newContainer}>
        <Typography className={classes.desc} color="initial" variant="p">
          Company and sector newsrun
        </Typography>
        <Paper className={classes.newsPaper}>
          {newsData.map((news) => (
            <NewsComponent
              companyName={news.companyName}
              date={news.date}
              title={news.title}
            />
          ))}
        </Paper>
      </div>
    </div>
  );
};

export default CompanyInfos;
